import State from '@/store/state';

// eslint-disable-next-line import/prefer-default-export
export const getInspectionId = (state: State) => state.inspection.currentInspection;
